import * as React from 'react';
import { ShipOverviewButton } from './ShipOverviewButton';
import { eventTracker } from '../../helpers/EventTracker/EventTracker';
import { __ } from '../../helpers/TranslationService';
import { ResetFilterBtn } from './ResetFilterBtn';
import styled from '@emotion/styled';

export interface IShipFacet {
    id: number;
    count: number;
    label: string;
}

interface IShipSearchBardProps {
    title: string;
    newSearch?: any;
    shipCategories: string;
    shipType: string;
    shipCruiselines: string;
    queryParams: {
        countryCode: string;
        filterParams: {
            shipCategory: string;
            shipType: string;
            ship: string;
            company: string;
        };
        limit: number;
        offset: number;
        sortString: string;
    };
    facets: {
        company: IShipFacet[];
        shipCategory: IShipFacet[];
        shipType: IShipFacet[];
    };
}

interface IShipSearchBarState {
    shipCategory: any;
    company: any;
    shipType: any;
}

const SearchBarStyled = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    background-color: ${({ theme }) => theme.background.brandColor2};
    padding: 24px;
    margin-left: 12px;
    margin-right: 12px;
    border-radius: ${({ theme }) => theme.container.borderRadius};
`;

const StyledForm = styled.form`
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 12px;
`;

const SearchHeaderWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
`;

const SearchBarTitle = styled.h3`
    margin: 0;
    font-size: 22px;
    color: ${({ theme }) => theme.colors.white[100]};
`;

export class ShipSearchBar extends React.Component<IShipSearchBardProps, IShipSearchBarState> {
    constructor(props) {
        super(props);
        this.state = {
            shipCategory: false,
            company: false,
            shipType: false,
        };
        this.resetFilter = this.resetFilter.bind(this);
        this.updateSelectedFacet = this.updateSelectedFacet.bind(this);
    }
    getFilters() {
        const { shipCategory, company, shipType } = this.state;
        return {
            shipCategory: shipCategory.id,
            company: company.id,
            shipType: shipType.id,
        };
    }

    resetFilter() {
        this.setState({
            shipCategory: false,
            company: false,
            shipType: false,
        });
        // Resets the select value

        this.props.queryParams.filterParams = {
            shipCategory: null,
            shipType: null,
            ship: null,
            company: null,
        };

        // Resets the state
        this.props.newSearch({
            shipCategory: '',
            shipType: '',
            company: '',
        });

        eventTracker.track({
            category: 'ship-overview',
            action: 'search mask',
            label: 'reset',
        });
    }

    updateSelectedFacet(facet, value) {
        this.setState((prevState) => {
            const selectedFacets = this.state;
            selectedFacets[facet] = value;
            return { ...prevState, selectedFacets };
        });
    }

    getShipCategories() {
        const categories = this.props.facets.shipCategory.map((item) => ({
            ...item,
            label: `${item.label} ${__('Stars', 'dreamlines')} `,
        }));
        return [{ label: this.props.shipCategories, id: -1, count: 0 }, ...categories];
    }

    render() {
        return (
            <SearchBarStyled>
                <SearchHeaderWrapper>
                    <SearchBarTitle data-test-id="ship-overview-page--search--header">
                        {this.props.title}
                    </SearchBarTitle>
                    <ResetFilterBtn onClick={this.resetFilter} />
                </SearchHeaderWrapper>

                <StyledForm>
                    <ShipOverviewButton
                        facet={[
                            { label: this.props.shipCruiselines, id: -1, count: 0 },
                            ...this.props.facets.company,
                        ]}
                        newSearch={this.props.newSearch}
                        type="company"
                        selectedFacet={this.state.company}
                        onChange={this.updateSelectedFacet}
                    />

                    <ShipOverviewButton
                        facet={[
                            { label: this.props.shipType, id: -1, count: 0 },
                            ...this.props.facets.shipType,
                        ]}
                        newSearch={this.props.newSearch}
                        type="shipType"
                        selectedFacet={this.state.shipType}
                        onChange={this.updateSelectedFacet}
                    />

                    <ShipOverviewButton
                        facet={this.getShipCategories()}
                        newSearch={this.props.newSearch}
                        type="shipCategory"
                        selectedFacet={this.state.shipCategory}
                        onChange={this.updateSelectedFacet}
                    />
                </StyledForm>
            </SearchBarStyled>
        );
    }
}
